import { render, staticRenderFns } from "./BuyBoxWidget.vue?vue&type=template&id=5f7402d1&"
import script from "./BuyBoxWidget.vue?vue&type=script&lang=js&"
export * from "./BuyBoxWidget.vue?vue&type=script&lang=js&"
import style0 from "./BuyBoxWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports